import { render, staticRenderFns } from "./audit-detail.vue?vue&type=template&id=c0da2bce&scoped=true&"
import script from "./audit-detail.vue?vue&type=script&lang=ts&"
export * from "./audit-detail.vue?vue&type=script&lang=ts&"
import style0 from "./audit-detail.vue?vue&type=style&index=0&id=c0da2bce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0da2bce",
  null
  
)

export default component.exports